import BeatLoader from "react-spinners/BeatLoader";
import BounceLoader from "react-spinners/MoonLoader";
import { createPortal } from "react-dom";

import { Wrapper } from "./Loading.style";
import { theme } from "styles/mui-config";

function LoadingCM({
  size = 10,
  color = theme.palette.primary.dark,
  isImg = false,
}) {
  if (isImg)
    return <BounceLoader color={color} size={size === 10 ? 40 : size} />;
  else
    return createPortal(
      <Wrapper>
        <BeatLoader color={color} size={size} />
      </Wrapper>,
      document.getElementById("loading")
    );
}

export default LoadingCM;
